/*
ge-form-submitted.js

-GE CONFIDENTIAL-
Type: Source Code

Copyright (c) 2021, GE Healthcare Co.
All Rights Reserved

This unpublished material is proprietary to GE Healthcare. The methods and
techniques described herein are considered trade secrets and/or
confidential. Reproduction or distribution, in whole or in part, is
forbidden except by express written permission of GE Healthcare.
*/
define('geFormSubmitted',['angular'], function () {

    // Module Definition
    var mod = angular.module('Directives.GeFormSubmitted', []);

    /**
     * @name geFormSubmitted
     * @type directive
     * @element FORM
     *
     * @description
     * When applied to a `<form>`, this directive will keep track of whether or not the `<form>`
     * has been submitted. This is done by adding a `$submitted` property to the `<form>` controller
     * and watching for the `submit` event. This directive was created to assist with the validation of
     * the `<form>`. It is used by the `geControlGroup` directive to ensure that the various controls
     * within the `<form>` are put into the `error` state if they are invalid when the `<form>` is submitted.
     *
     * @example
     * <form name="exampleForm" ng-submit="submitExampleForm()" form-submitted novalidate></form>
     *
     */
    mod.directive('geFormSubmitted', [function () {
        return {
            /**
             * Use the restrict option to specify how this directive can be applied to HTML elements.
             *  'A' = Attribute (e.g. <div my-directive>)
             *  'C' = Class     (e.g. <div class="my-directive">)
             *  'E' = Element   (e.g. <my-directive>)
             *  'M' = Comment   (e.g. <!-- directive: my-directive -->)
             */
            restrict: 'A',
            /**
             * Use the require option to have a controller injected into the link function as an
             * additional argument. Prefix this option's value with '^' if the controller belongs
             * to a parent element. If the '^' prefix is not included, the directive will look for
             * the controller on its own element.
             */
            require: 'form',
            /**
             * Use the link function to make changes to the directive's HTML after the directive's
             * scope has been attached to it. Normally, this function is used for registering DOM
             * listeners (i.e., $watch expressions on the scope) as well as updating the DOM.
             *
             * @param scope   - the directive's scope object.
             * @param element - the jqLite-wrapped element that this directive matches.
             * @param attrs   - the matched element's attributes and their corresponding values.
             */
            link: function (scope, element, attrs, formCtrl) {
                // Add an additional property to the form's controller to track submission
                formCtrl.$submitted = false;

// Watch for the submit event and update the $submitted property
                element.on('submit', function () {
                    scope.$apply(function () {
                        formCtrl.$setSubmitted();
                    });
                });
            }
        };
    }]);

});

